import { normalizeCarrierCode } from './filters/carrier/definitions';

export const tabPricePerAirline = 0;
export const tabCustomSearch = 1;

export const getBestPriceByAirline = searchResults => {
  const normalizedAirlines = [
    ...new Set(
      searchResults.map(el => normalizeCarrierCode(el.cluster.carrier.code))
    ),
  ];

  const bestPriceByAirline = normalizedAirlines.map(normalizedCode => {
    const matchingFlights = searchResults
      .map((flight, index) => ({ ...flight, originalIndex: index }))
      .filter(
        flight =>
          normalizeCarrierCode(flight.cluster.carrier.code) === normalizedCode
      );

    const bestFlight = matchingFlights.reduce(
      (min, flight) =>
        flight.cluster.composition_price.total <
        min.cluster.composition_price.total
          ? flight
          : min,
      matchingFlights[0]
    );

    const canonicalCarrier = searchResults.find(
      flight =>
        normalizeCarrierCode(flight.cluster.carrier.code) === normalizedCode &&
        flight.cluster.carrier.code === normalizedCode
    )?.cluster.carrier;

    const carrierToUse = canonicalCarrier || bestFlight.cluster.carrier;

    return {
      ...bestFlight,
      cluster: {
        ...bestFlight.cluster,
        carrier: carrierToUse,
      },
    };
  });

  return bestPriceByAirline;
};

export const getCustomAirline = searchResults => {
  const normalizedAirlines = [
    ...new Set(
      searchResults.map(element =>
        normalizeCarrierCode(element.combinations[0].cluster.carrier.code)
      )
    ),
  ];

  const bestPriceByAirline = normalizedAirlines.map(normalizedCode => {
    const matchingFlights = searchResults
      .map((flight, index) => ({ ...flight, originalIndex: index }))
      .filter(
        flight =>
          normalizeCarrierCode(flight.combinations[0].cluster.carrier.code) ===
          normalizedCode
      );

    const bestFlight = matchingFlights.reduce(
      (min, flight) =>
        flight.combinations[0].cluster.composition_price.total <
        min.combinations[0].cluster.composition_price.total
          ? flight
          : min,
      matchingFlights[0]
    );

    const canonicalCarrier =
      searchResults.find(
        flight =>
          normalizeCarrierCode(flight.combinations[0].cluster.carrier.code) ===
            normalizedCode &&
          flight.combinations[0].cluster.carrier.code === normalizedCode
      )?.combinations[0].cluster.carrier ||
      bestFlight.combinations[0].cluster.carrier;

    return {
      ...bestFlight,
      combinations: [
        {
          ...bestFlight.combinations[0],
          cluster: {
            ...bestFlight.combinations[0].cluster,
            carrier: canonicalCarrier,
          },
        },
        ...bestFlight.combinations.slice(1),
      ],
    };
  });

  return bestPriceByAirline;
};

export const getTimeCluster = legs => {
  if (!legs?.length) return 0;

  let totalTime = 0;

  for (const leg of legs) {
    if (!leg.options?.length) continue;

    const bestOption = leg.options.reduce((best, current) =>
      current.flight_time < best.flight_time ? current : best
    );

    totalTime += bestOption.flight_time;
  }

  return totalTime;
};

export const getMostConvenientFlight = newResult => {
  const calculateVariation = (minValue, currentValue) =>
    100 - (currentValue * 100) / minValue;

  const getFlightData = index => ({
    index,
    time: getTimeCluster(newResult?.[index]?.legs),

    price: newResult?.[index]?.cluster?.composition_price.total,
  });

  let bestFlights = {
    cheapest: getFlightData(0),
    fastest: getFlightData(0),
  };

  const possibleConvenientFlights = [];

  for (let i = 1; i < newResult.length; i++) {
    const currentFlight = getFlightData(i);

    // actualizar vuelo mas rapido
    if (currentFlight.time < bestFlights.fastest.time) {
      bestFlights.fastest = currentFlight;
    }

    // Vuelos convenientes
    if (currentFlight.time < bestFlights.cheapest.time) {
      const timeVariation = calculateVariation(
        bestFlights.cheapest.time,
        currentFlight.time
      );
      const priceVariation = calculateVariation(
        currentFlight.price,
        bestFlights.cheapest.price
      );
      const score = timeVariation - priceVariation;

      if (score > 0) {
        possibleConvenientFlights.push({ ...currentFlight, score });
      }
    }
  }

  if (possibleConvenientFlights.length > 0) {
    possibleConvenientFlights.sort((a, b) => b.score - a.score);
    bestFlights.convenient = possibleConvenientFlights[0];
  } else {
    // determinar si el vuelo mas rapido o mas barato es mas conveniente
    const timeVariation = calculateVariation(
      bestFlights.cheapest.time,
      bestFlights.fastest.time
    );
    const priceVariation = calculateVariation(
      bestFlights.fastest.price,
      bestFlights.cheapest.price
    );

    bestFlights.convenient =
      priceVariation < timeVariation
        ? bestFlights.fastest
        : bestFlights.cheapest;
  }

  const { cheapest, fastest, convenient } = bestFlights;
  return {
    cheapest: { ...newResult[cheapest.index], index: cheapest.index },
    fastest: { ...newResult[fastest.index], index: fastest.index },
    convenient: { ...newResult[convenient.index], index: convenient.index },
  };
};

export const returnTime = time => {
  return time?.slice(11, 16);
};

export const findScale = flight => {
  const scales = {
    0: 'Directo',
    1: 1 + ' Escala',
    2: flight?.scales_qty + ' Escalas',
  };

  if (+flight?.scales_qty > 2) {
    return flight?.scales_qty + ' Escalas';
  }

  return scales[+flight?.scales_qty];
};

export const flightTimeConvert = num => {
  const hours = Math.floor(num / 60);
  const minutes = num % 60;

  if (+hours === 0) {
    return minutes + ' min';
  }
  if (+minutes === 0) {
    if (+hours === 1) {
      return hours + ' h';
    } else {
      return hours + ' hs';
    }
  }
  if (hours === 1) {
    return hours + ' h ' + minutes + ' min';
  }
  return hours + ' hs ' + minutes + ' min';
};

export const flightTimeConvertSimple = num => {
  const hours = Math.floor(num / 60);
  const minutes = num % 60;

  if (+hours === 0) {
    return minutes + 'm';
  }
  if (+minutes === 0) {
    return hours + 'h';
  }
  return hours + 'h ' + minutes + 'm';
};
